/* ******************************** Import Packages ******************************* */
import React, { Suspense, useState, useRef, useEffect } from "react";
import {
  Outlet,
  //  Route, Routes
} from "react-router-dom";
import {
  LazyMotion,
  domAnimation,
} from "framer-motion";


import { FaGreaterThan } from "react-icons/fa6";
import { IoLogOutOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { Routes } from "../../constants/routes";
import { toast } from "react-toastify";
/***************************** Import images for logout *****************************/
// import PowerOff from "../../assets/images/poweroffsolid.svg";
import ProfileIcon from "../../assets/images/blank_avatar.png";
import { TbUserCog } from "react-icons/tb";
import { prettifyLabel } from "../../utils/commonFunction";
import { Details, Name, Logout, Profile } from "../header/style";
// import { postLogoutRequestData } from "../../api/create";
import "../header/header.css";
import { Link } from "react-router-dom";

/***********************Import styled component level*********************************/
import { Container, ContentStyled } from "./style";
import { useSelector } from "react-redux";


const Content = (props: any) => {
  const {
    onClick
  } = props;

  const sidebardata = useSelector((store: any) => store.SideBar.sidebar);

  const navBar = useSelector((store: any) => store.NavbarReduce.navbar);


  const [profileHover, setProfileHover] = useState(false);
  const [user, setUser] = useState({}) as any;
  const profileRef = useRef<HTMLDivElement | null>(null);
  //   const profileDropDownData = useSelector(
  //     (store) => store.profileDropdown.profileDropDown
  //   );
  useEffect(() => {
    const data: any = localStorage.getItem("loggedUser") !== 'undefined' ? localStorage.getItem("loggedUser") : undefined;
    const user: any = data ? JSON.parse(data) : { access: [] };
    setUser(user);
  }, []);

  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState<any[]>([]);
  const generateBreadcrumbs = () => {
    const capitalizeFirstLetter = (str: string) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const pathSegments = location.pathname.split("/").filter(Boolean); // Split and remove empty strings
    const breadcrumbLinks = pathSegments.map((segment, index) => {
      const path = `/${pathSegments.slice(0, index + 1).join("/")}`;
      const matchedRoute = Routes.find((route) => route.route === path);
      // if (!matchedRoute && segment === "account-settings") {
      //   return {
      //     name: "Account Settings",
      //     path: "/account-settings/profile-settings",
      //   };
      //   // Skip non-matching routes
      // }

      return {
        name: matchedRoute?.name || capitalizeFirstLetter(segment), // Use route name or fallback to the segment
        path,
      };
    });

    setBreadcrumbs(breadcrumbLinks);
  };

  useEffect(() => {
    generateBreadcrumbs();
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        profileRef.current &&
        !profileRef.current.contains(event.target as Node)
      ) {
        setProfileHover(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleProfileHover = () => {
    setProfileHover((prevState) => !prevState);
  };

  const logout = () => {
    // Clear the access token from local storage
    localStorage.removeItem("accessToken");
    localStorage.removeItem("loggedUser");
    toast.success("Logged out Successfully");

    // Redirect to the login page or perform other logout actions
    setTimeout(() => {
      window.location.href = "/login"; // Redirect to the login page
    }, 3000); // Delay in milliseconds
  };

  return (
    <LazyMotion features={domAnimation}>
      <ContentStyled
        sidebardata={sidebardata as any}
        sidebardata1={navBar as any}
        onClick={onClick}
      >
        <Container className="w-full p-[10px] pl-[2px] pr-[2px] border border-[#EEEFF2] p-[16px] bg-white rounded-[12px]">
          {/* <m.div
            key={window.location.pathname}
            transition={{ delay: 0.2, type: "spring" }}
            initial={{ x: -300, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
          > */}
          <div className="w-full">
            <div className="grid grid-cols-12">
              <div className="col-span-4 flex items-center text-left">
          
                {/* <span className="text">{currentPageName}</span> */}
                <nav className="breadcrumb flex items-center">
                  {breadcrumbs.map((breadcrumb: any, index: any) => (
                    <>
                      <span key={breadcrumb.path} className="">
                        <Link
                          to={breadcrumb.path}
                          className="breadcrumb-link underline-offset-1"
                        >
                          {prettifyLabel(breadcrumb.name)}
                        </Link>
                      </span>
                      {index < breadcrumbs.length - 1 && <FaGreaterThan className="mx-2 w-[0.7rem] h-[0.7rem]" color="#848888" />}
                    </>
                  ))}
                </nav>
              </div>
              <div className="col-span-4 flex justify-center items-center rounded-[8px]">
                <h6 className="font-bold text-primary-light">ScribeSmart</h6>
              </div>
              <div
                className="col-span-4 flex justify-end items-center"
                // onMouseEnter={() => setProfileHover(true)}
                // onMouseLeave={() => setProfileHover(false)}
              >
                <Profile
                  ref={profileRef}
                  clicked={false}
                  onClick={() => handleProfileHover()}
                >
                  <img role="none" src={ProfileIcon} alt="Profile" />
                </Profile>
              </div>
            </div>
          </div>
          <Details
            clicked={profileHover}
            // onMouseEnter={() => setProfileHover(true)}
            // onMouseLeave={() => setProfileHover(false)}
          >
            <div className="p-2 absolute top-[-5%] bg-[#025963] rotate-45 right-[18%]">
                 
            </div>
            <Name>
              <h4 className="text-center name-pop-up pl-3">
                {user?.email ? user.email : ""}
              </h4>
            </Name>
            <Link
              to="/account-settings/profile-settings"
              className="cursor-pointer hover:underline pl-4 p-3"
              onClick={() => handleProfileHover()}
            >
              <div className="flex items-center ">
                <TbUserCog size={"1.5em"} className="mr-2" />
                Account Settings
              </div>
            </Link>
            <hr className="w-full border-t border-gray-300" />
            <div className="flex items-center pl-4 hover:underline " onClick={() => logout()}>
              <IoLogOutOutline size={"1.5em"} className="mr-2" />
              <Logout >
                Logout
                {/* <img src={PowerOff} alt="logout" /> */}
              </Logout>
            </div>
          </Details>
          <Suspense
            fallback={
              <div className="d-flex justify-content-center align-items-center">
                {/* <img src={SpinnerImg} width="6%" height="6%" /> */}
              </div>
            }
          >
            <Outlet />
          </Suspense>
          {/* </m.div> */}
        </Container>
      </ContentStyled>
    </LazyMotion>
  );
};
export default Content;
